const trackPrivacy = (evt: Event) => {
  const customEvent = evt as CustomEvent;
  const privacySettings = customEvent.detail.updatedCookieSettings;
  const parentOverlay = customEvent.detail.panel.parentElement;

  const updateEventData = {
    event: 'privacy:update',
    analytics: privacySettings.get('allow_tracking_cookies'),
    marketing: privacySettings.get('allow_marketing_cookies'),
  };

  document.body.dispatchEvent(
    new CustomEvent('jb-tracking', {
      detail: updateEventData,
    }),
  );

  if (!parentOverlay || parentOverlay.nodeName !== 'JB-OVERLAY') return;
  parentOverlay.closeOverlay();
};

document.addEventListener('jb-privacy-panel:update', trackPrivacy);
